import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

export const useNextPredicatePartOrder = ({ parentUuid }) => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);
    const target = predicates?.[parentUuid] ? { ...predicates?.[parentUuid] } : null;
    const children = target?.predicateParts ?? [];

    const newPredicateOrder =
        children.reduce((acc, curr) => {
            return Math.max(...[predicates[curr]?.predicatePartOrder, acc]);
        }, 0) + 1;

    return newPredicateOrder;
};
